import { css } from '@emotion/react';
import { flex, themed } from '@spotnana/blocks/src/utils';
import { paddings } from '@spotnana/blocks/src/utils/styling/utilityTokens';

export const container = themed(
  ({ palette }) => css`
    background-color: ${palette.bg.infoSubtle};
    ${paddings.y.tight}
    ${paddings.x.extraCozy}
    ${flex.init}
    gap: 0.5rem;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    margin: -2rem -2rem 0 -2rem;
  `,
);

export const policy = themed(
  ({ palette }) => css`
    color: ${palette.icon.infoLink};
    height: 20px;
    width: 20px;
  `,
);

export const close_cross = themed(
  ({ palette }) => css`
    height: 16px;
    width: 16px;
    color: ${palette.icon.primary};
  `,
);
